import { Trip } from "../trip/types";
import {
  AdditionalItem,
  DirectOrder,
  DirectOrderTrip,
  DIRECTS_ORDER_FIELDS,
  State,
} from "./types";

export default {
  /**
   * Retrieves all trip values from the `directOrder` object.
   *
   * This method returns an array of all `DirectOrderTrip` objects stored in the
   * `directOrder` object within the store's state.
   * @param {State} state - The state of the store.
   * @returns {DirectOrderTrip[]} - An array of all trips in the `directOrder` object.
   */
  getOrder: (state: State): DirectOrder | null => {
    return state.directOrder || null;
  },
  getOrderFormValues: (state: State): DirectOrderTrip[] => {
    return Object.values(state.directOrder?.trip);
  },
  getCancelTrips: (state: State): number[] => {
    return state.directOrder.cancel_trips;
  },
  /**
   * Retrieves additional items associated with the current order.
   * @param {State} state - The state of the store.
   * @returns {AdditionalItem[]} - Array of additional items for the current order.
   */
  getAdditionalItems: (state: State): AdditionalItem[] => {
    return state.directOrder.additional_items || [];
  },
  /**
   * Get trip by gen_tid from the direct order store
   * @param {State} state - The state of the store.
   * @returns {Function} - A function that takes a gen_tid and returns the corresponding Trip
   */
  getTripByGenId:
    (state: State) =>
    (genTid: string): Trip | undefined => {
      if (!state.directOrder || !state.directOrder.trip) {
        return undefined;
      }

      const allTrips = state.directOrder.trip;
      const directOrderTrip = Object.values(allTrips).find(
        (trip) => trip.gen_tid === genTid
      );

      if (!directOrderTrip) return undefined;

      // Manually create a Trip object with required properties
      return {
        id: directOrderTrip[DIRECTS_ORDER_FIELDS.ID],
        via_points:
          directOrderTrip[DIRECTS_ORDER_FIELDS.ROUTE_POINTS]?.oneway || [],
        start_time:
          directOrderTrip[
            DIRECTS_ORDER_FIELDS.DEPARTURE_DATETIME
          ]?.toString() || "",
        cp_trip_status: directOrderTrip[DIRECTS_ORDER_FIELDS.TRIP_STATUS],
        trip_type: directOrderTrip[DIRECTS_ORDER_FIELDS.TRIP_TYPE],
        org_id: directOrderTrip[DIRECTS_ORDER_FIELDS.ORG_ID],
      } as Trip;
    },
};
